import classnames from 'classnames/bind'
import { Fragment } from 'react'
import { PropsWithClassName } from '~/@types/generic'

import VideoComponentForwarded from '~/components/Abstracts/Video'
import { ProductCardProps } from '~/components/Slices/ProductCard'
import { EmblaSlider } from '~/components/UI/EmblaSlider'
import Image from '~/components/UI/Image'

import { useTheme } from '~/providers/ThemeProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

const IMAGE_SIZES = {
  DEFAULT: [{ ratio: 24 / 24 }],
}

export function ProductCardCover({
  className,
  image: asset,
  imageHover: assetHover,
  priority,
  sizesFromBreakpoints,
  withSlider,
}: PropsWithClassName<
  Pick<
    ProductCardProps,
    'image' | 'imageHover' | 'priority' | 'sizesFromBreakpoints' | 'withSlider'
  >
>) {
  const { screens } = useTheme() ?? {}

  const assets = [asset, assetHover]?.filter(Boolean)

  return (
    <EmblaSlider
      className={cx(css.ProductCardCover, !withSlider && css.isDisabled)}
      containerClassName={cx(css.slider, !withSlider && css.isDisabled)}
      controlsClassName={css.controls}
      options={{
        containScroll: 'trimSnaps',
        align: 'start',
        loop: false,
        active: withSlider ? assets?.length > 1 : false,
        breakpoints: { [`(min-width: ${screens.md}px)`]: { active: false } },
      }}>
      {assets?.map((asset, index) => {
        const cn = cx(
          className,
          css.slide,
          assets?.length > 1 && index === 0 && css.isHoverable,
          index === 1 && css.hoveredAsset,
        )

        return (
          <Fragment key={`product_card_cover_${index}`}>
            {asset?.image && (
              <Image
                draggable="false"
                layout="fill"
                objectFit="cover"
                className={cn}
                sizesFromBreakpoints={
                  sizesFromBreakpoints ?? IMAGE_SIZES.DEFAULT
                }
                asPlaceholder
                priority={priority && index === 0}
                {...asset?.image}
              />
            )}

            {asset?.video && (
              <div className={cn}>
                <VideoComponentForwarded
                  {...asset?.video}
                  className={css.video}
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>
            )}
          </Fragment>
        )
      })}
    </EmblaSlider>
  )
}
